import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { Device, from, until } from '@helpers/media';
import { h3, paragraphRegular } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
import SectionWrapperStyles from '../Global/SectionWrapper/SectionWrapper.styles';
import NavigationStyles from '../Navigation/Navigation.styles';
const Container = styled(SectionWrapper) `
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${rgba(brand.black, 0.8)};
  width: 100%;
  height: 100%;
  display: none;
  z-index: 100;
  padding: 0;

  @media ${from(Device.Tablet)} {
    padding: 64px;
  }

  ${SectionWrapperStyles.SiteWide} {
    @media ${until(Device.Tablet)} {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &[data-visible='true'] {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const Inner = styled.div `
  position: relative;
  margin: auto;
  width: 100%;
  max-width: 912px;
  height: 100%;
  max-height: 685px;
  background-color: ${brand.black};
  display: flex;
  flex-direction: column;

  @media ${from(Device.Tablet)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: calc(100vh - 128px);
  }
`;
const MediaContainer = styled.div `
  overflow: hidden;
  position: relative;

  @media ${until(Device.Tablet)} {
    height: 65vh;
  }
`;
const ImageWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ContentContainer = styled.div `
  padding: 76px 32px;
  display: flex;
  align-items: center;

  @media ${until(Device.Tablet)} {
    padding: 0;
    overflow: hidden;
    position: relative;
  }
`;
const OverlayTop = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 30px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 1) 20%, rgba(255, 255, 255, 0) 100%);

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const OverlayBottom = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 1) 30%, rgba(255, 255, 255, 0) 100%);

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ContentInner = styled.div `
  @media ${until(Device.Tablet)} {
    padding: 24px 22px;
    overflow: auto;
    height: 35vh;
    padding-bottom: 60px;
  }

  a {
    color: inherit;
  }
`;
const Title = styled.h3 `
  ${h3};
`;
const Subtitle = styled.p `
  ${paragraphRegular};
`;
const Content = styled.div `
  ${paragraphRegular};

  p a {

    &:focus {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }
`;
const CloseBtn = styled(NavigationStyles.CloseBtn) `
  &.focus-ring {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }
`;
const Link = styled.a `
  ${paragraphRegular};
  color: ${brand.white};
`;
const ModalStyles = {
    CloseBtn,
    Container,
    Content,
    ContentContainer,
    ContentInner,
    Image,
    ImageWrapper,
    Inner,
    Link,
    MediaContainer,
    OverlayBottom,
    OverlayTop,
    Subtitle,
    Title,
};
export default ModalStyles;
